import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const BOOK_URL = 'https://calendar.app.google/6g62S4xtRa8eWipt5';

function Footer() {
  return (
    <footer className="site-footer grain">
      {/* CTA band */}
      <section className="cta-band" aria-labelledby="footer-cta-title">
        <div className="container">
          <div className="cta-band__grid">
            <div>
              <p className="eyebrow" data-reveal>Free 30-minute consultation</p>
              <h2 className="cta-band__title" id="footer-cta-title" data-split>
                Ready to <em>streamline</em> operations?
              </h2>
              <p className="cta-band__lead" data-reveal data-delay="0.15">
                Let&rsquo;s discuss how AI automation can save your team 20+ hours weekly while
                maintaining privacy and security.
              </p>
              <div className="cta-band__actions" data-reveal data-delay="0.25">
                <a href={BOOK_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg" data-magnetic>
                  <i className="fa-solid fa-calendar-check" aria-hidden="true"></i>
                  Book a Demo
                </a>
                <Link to="/contact" className="btn btn-outline-light btn-lg">
                  Contact us
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
            <ul className="cta-band__meta ticks" data-reveal-stagger>
              <li>No commitment required</li>
              <li>Canadian data residency</li>
              <li>Privacy-first automation</li>
            </ul>
          </div>
        </div>
      </section>

      <div className="site-footer__main">
        <div className="container">
          <div className="site-footer__grid">
            <div>
              <Link className="brand" to="/" aria-label="Moneli Automation — home">
                <span className="brand__mark"><img src={logo} alt="" width="40" height="40" /></span>
                <span className="brand__text">
                  <span className="brand__name">Moneli</span>
                  <span className="brand__sub">Automation Inc.</span>
                </span>
              </Link>
              <p className="site-footer__blurb">
                Human-centered AI automation for healthcare, property management, and public-sector modernization.
              </p>
            </div>
            <nav aria-labelledby="footer-nav-1">
              <h2 id="footer-nav-1">Navigate</h2>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/services">Solutions</Link></li>
                <li><Link to="/services/web-marketing">Web &amp; Marketing</Link></li>
                <li><Link to="/case-studies">Case Studies</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </nav>
            <nav aria-labelledby="footer-nav-2">
              <h2 id="footer-nav-2">Explore</h2>
              <ul>
                <li><Link to="/monelillm">MoneliLLM</Link></li>
                <li><Link to="/demos">Demos</Link></li>
                <li><Link to="/blog">Blog</Link></li>
              </ul>
            </nav>
            <div>
              <h2>Connect</h2>
              <div className="social">
                <a
                  aria-label="LinkedIn"
                  href="https://www.linkedin.com/company/moneliautomation/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-linkedin-in" aria-hidden="true"></i>
                </a>
                <a
                  aria-label="YouTube"
                  href="https://www.youtube.com/@moneliautomation"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-youtube" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <p className="site-footer__word" aria-hidden="true">Moneli</p>
        <div className="site-footer__bottom">
          <small>&copy; {new Date().getFullYear()} Moneli Automation Inc.</small>
          <nav aria-label="Legal">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/security-policy">Security</Link>
            <Link to="/accessibility-statement">Accessibility</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
